import httpHelper from '../../../../utils/httpHelper';

const APP_CONFIG = JSON.parse(localStorage.getItem('appConfig'));

const service = {
  async getVehicles() {
    const endPoint = `vehicle/findAll/list`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      {},
      'Bearer',
    );
    return result;
  },

  async getLastTransportation(params) {
    const { param, vehicleId } = params;
    const endPoint = `kv/transportation/findByVehicleId/${vehicleId}`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      param,
      'Bearer',
    );
    return result;
  },

  async getReportingRequests(params) {
    const { param } = params;
    if (param.userId) {
      const endPoint = `/reporting-request/findByUserIdAndSchemaId`;
      const result = await httpHelper.makeGetRequest(
        APP_CONFIG,
        endPoint,
        param,
        'Bearer',
      );
      return result;
    } else {
      const endPoint = `/reporting-request/findBySchemaId/WeeklyDutySafetyReport`;
      const result = await httpHelper.makeGetRequest(
        APP_CONFIG,
        endPoint,
        param,
        'Bearer',
      );
      return result;
    }
  },

  async getReportingResponses(params) {
    const endPoint = `/reporting-response`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      params,
      'Bearer',
    );
    return result;
  },

  async getReportingRequestByUserId(params) {
    const { param, userId } = params;
    const endPoint = `/reporting-request/findByUserId/${userId}`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      param,
      'Bearer',
    );
    return result;
  },

  async saveReportingRequest(params) {
    const endPoint = `kv/vehicle-safety-report/reporting`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      params,
      'Bearer',
    );
    return result;
  },

  async getTransportationReportByTransportationId(params) {
    const { id } = params;
    const endPoint = `kv/vehicle-safety-report/getTransportationReport?transportationId=${id}`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      {},
      'Bearer',
    );
    return result;
  },
  async getLastTransportation(params) {
    const { param, vehicleId } = params;
    const endPoint = `kv/transportation/findByVehicleId/${vehicleId}`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      param,
      'Bearer',
    );
    return result;
  },
  async getTransportationsByVehicleIdAndEndDateBetween(params) {
    const { param, vehicleId } = params;
    const endPoint = `kv/transportation/findByVehicleIdAndEndDateBetween/${vehicleId}`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      param,
      'Bearer',
    );
    return result;
  },
};

export default service;
